/* __next_internal_client_entry_do_not_use__ default auto */ import useId from '@mui/utils/useId';
export default useId;
